'use strict';

var _dontTrack = require('./dont-track');

var _dontTrack2 = _interopRequireDefault(_dontTrack);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

if (navigator.userAgent.indexOf('MSIE') >= 0) {
  window.location.href = '/unsupported.html';
} else {
  require('./polyfill');
  if (!_dontTrack2.default) {
    require('./segment-init');
    require('./taplytics/init');
  }
}


// WEBPACK FOOTER //
// ./node_modules/@rategravity/frontend/modules/init.js